module.exports = __webpack_public_path__ + "img/academy-badge-fundamental-course.c852584.svg";